// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __assign } from "tslib";
import { Category } from '@aws-amplify/core';
export var getGeoUserAgentDetails = function (action, customUserAgentDetails) {
    return __assign({ category: Category.Geo, action: action }, customUserAgentDetails);
};
//# sourceMappingURL=utils.js.map